import { Size } from '@geom';

export interface CornerRadiusOpts {
  topLeft: number | Size;
  topRight: number | Size;
  bottomLeft: number | Size;
  bottomRight: number | Size;
}

export interface NormalizedCornerRadiusOpts {
  topLeft: Size;
  topRight: Size;
  bottomLeft: Size;
  bottomRight: Size;
}

export function normalizeCornerRadius(
  radius: number | Partial<CornerRadiusOpts>
): NormalizedCornerRadiusOpts {
  function toSize(value: number | Size | undefined): Size {
    if (value === undefined) return Size.ZERO;
    return typeof value === 'number' ? new Size(value, value) : value;
  }

  if (typeof radius === 'number') {
    const s = new Size(radius, radius);
    return {
      topLeft: s,
      topRight: s,
      bottomLeft: s,
      bottomRight: s
    };
  }

  return {
    topLeft: toSize(radius.topLeft),
    topRight: toSize(radius.topRight),
    bottomLeft: toSize(radius.bottomLeft),
    bottomRight: toSize(radius.bottomRight)
  };
}

export function isUniformCornerRadius(radius: NormalizedCornerRadiusOpts): boolean {
  const tl = radius.topLeft;
  return (
    tl.width === radius.topRight.width &&
    tl.height === radius.topRight.height &&
    tl.width === radius.bottomRight.width &&
    tl.height === radius.bottomRight.height &&
    tl.width === radius.bottomLeft.width &&
    tl.height === radius.bottomLeft.height
  );
}

export function isZeroCornerRadius(radius: NormalizedCornerRadiusOpts): boolean {
  return (
    radius.topLeft.width === 0 &&
    radius.topLeft.height === 0 &&
    radius.topRight.width === 0 &&
    radius.topRight.height === 0 &&
    radius.bottomRight.width === 0 &&
    radius.bottomRight.height === 0 &&
    radius.bottomLeft.width === 0 &&
    radius.bottomLeft.height === 0
  );
}
